import { useState } from "react";
import axios from 'axios';

const LoginForm = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');

    const handleSubmit = async (e) =>{
        e.preventDefault(); 

        const authObject = { 'Project-ID': "583aa3f4-80bf-4a36-8ef6-52f4d8b96536", 'User-Name': username, 'User-Secret': password };

        try {

            //username | password => chatengine -> give messages

            await axios.get('https://api.chatengine.io/chats', { headers: authObject });

            localStorage.setItem('username', username);
            localStorage.setItem('password', password);

            window.location.reload();
            
            // if that's works out -> logged in

        } catch (error) {
            setError('The username or password you entered is incorrect.') 
            //if that's not works out -> error try new username..

        }

    }

    return (
        <div className="wrapper">
            <div className="form">
                <h1 className="title">Bored Chat Application</h1>
                <form onSubmit={handleSubmit}>
                    <input type="text" value={username} onChange={(e) => setUsername(e.target.value)} className="input" placeholder="Username" required />
                    <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="input" placeholder="Password" required />
                    <div align="center">
                        <button type="submit" className="button">
                            <span>Start Chatting</span>
                        </button>
                    </div>
                    <h2 className="error">{error}</h2>
                </form>
            </div>
        </div>
    );
}

export default LoginForm;